import React from 'react';
import { findDOMNode } from 'react-dom';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import {
  Container,
  Icon,
  PageTitle,
  SectionHeader,
  SectionHeaderIcon,
  SectionHeaderText
} from '../../../ui';
import { Track } from '../../analytics';
import { paymentActions } from '../../redux';
import { EnsureVisible } from '../../Utilities';
import RouterBackLink from '../RouterBackLink';
import CreditCardForm from './components/CreditCardForm';

const isDev = process.env.NODE_ENV === 'development';
const isHttps = window.location.protocol === 'https:';

interface CardRoute
  extends RouteComponentProps<
    {
      backurl: string;
    },
    {}
  > {}

type Props = CardRoute & MapStateToProps & MapDispatchToProps;

class CreditCardPage extends React.Component<Props, {}> {
  public UNSAFE_componentWillMount() {
    if (!isDev && !isHttps) {
      this.props.router.replace('/where');
    }
  }
  public componentDidMount() {
    EnsureVisible(findDOMNode(this));
  }

  private onSuccess = () => {
    //     Track('Payments', 'Add New Card Success');
    if (this.props.params.backurl) {
      this.props.router.push(this.props.params.backurl.substring(1));
      // hashHistory.push(this.props.params.backurl.substring(1));
    } else {
      this.props.router.goBack();
    }
    Track('Payments', 'Add New Card Done');
  };
  private onFail = () => {
    Track('Payments', 'Add New Card Failure');
  };

  public render() {
    const { translate, params } = this.props;

    return (
      <Container maxWidth="lg">
        <PageTitle>{translate('Payment')}</PageTitle>

        <RouterBackLink to={params.backurl.substring(1)}>
          {translate('Back')}
        </RouterBackLink>

        <SectionHeader>
          <SectionHeaderIcon>
            <Icon
              fontSize="large"
              aria-hidden
              color="inherit"
              className="ei icon_creditcard"
            />
          </SectionHeaderIcon>

          <SectionHeaderText title={translate('Add_a_new_card') as string} />
        </SectionHeader>

        <CreditCardForm onSuccess={this.onSuccess} onFail={this.onFail} />
      </Container>
    );
  }
}

export { CreditCardPage };

type MapStateToProps = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: WebOrder.State) => {
  return {
    translate: getTranslate(state.locale)
  };
};

type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;
const mapDispatchToProps = (
  dispatch: ThunkDispatch<WebOrder.State, {}, Action>
) => {
  return {
    cancelAddCardBridge: () => {
      dispatch(paymentActions.cancelAddBridge());
    }
  };
};

export default connect<MapStateToProps, MapDispatchToProps, CardRoute>(
  mapStateToProps,
  mapDispatchToProps
)(CreditCardPage);
